import { createBrowserHistory } from "history"
export let history = createBrowserHistory()
export function resetState() {
    history.replace({ ...history.location, state: {} });
}